/* src/app/views/admin/doctor-calendar/doctor-calendar.component.css */
:ng-deep .ngx-material-timepicker-toggle {
  display: none !important;
}
::ng-deep .ngx-timepicker {
  border-bottom: none !important;
}
/*# sourceMappingURL=doctor-calendar.component.css.map */
